import React from "react";
import { ChildrenProps, ClassNameProps, Column, makeClassName, mappedArray, StyleProps } from "@hex-insights/core";
import styles from "./base.module.css";

export type CircleLoadingPlaceholderProps = {
	size?: string;
} & Partial<ClassNameProps & StyleProps>;

export function CircleLoadingPlaceholder({ size = "2rem", className, style }: CircleLoadingPlaceholderProps) {
	return (
		<div
			className={makeClassName(styles["circle"], styles["loading"], className)}
			style={{ "--size": size, ...style } as React.CSSProperties}
		></div>
	);
}

export type MediaLoadingPlaceholderProps = Partial<ClassNameProps & StyleProps>;

export function MediaLoadingPlaceholder({ className, style }: MediaLoadingPlaceholderProps) {
	return <div className={makeClassName(styles["media"], styles["loading"], className)} style={style}></div>;
}

export type TextLineLoadingPlaceholderProps = Partial<ClassNameProps & StyleProps & ChildrenProps>;

export function TextLineLoadingPlaceholder({ className, style, children }: TextLineLoadingPlaceholderProps) {
	return (
		<div
			className={makeClassName(
				styles["text-line"],
				children ? styles["text-line--with-sample"] : "",
				styles["loading"],
				"no-select",
				className,
			)}
			style={style}
		>
			{children}
		</div>
	);
}

export type TextBlockLoadingPlaceholderProps = {
	lines?: number;
} & Partial<ClassNameProps & StyleProps>;

export function TextBlockLoadingPlaceholder({ lines = 3, className, style }: TextBlockLoadingPlaceholderProps) {
	return (
		<Column
			justify="spaced-start"
			verticalSpacing="0.25rem"
			className={makeClassName(styles["text-block"], className)}
			style={style}
		>
			{mappedArray(lines, (i) => (
				<TextLineLoadingPlaceholder key={i} className={styles["text-block__line"]} />
			))}
		</Column>
	);
}
